import React from "react";
import { cn } from "../../../lib/cn";

/**
 * Badge — ui-v2.5. Estado o etiqueta, 6 tonos semánticos (no decorativos).
 * Especificación: ui-v2.5-catalogo-componentes.html · sección Badge.
 * NO es el Badge de ui-v2 (aquel es shadcn con `variant`); aquí el contrato es `tone`.
 *
 * Base: 11px/500, padding 2px 8px, radio full, borde 1px, gap 4px, nowrap.
 * <Badge tone="waiting|received|progress|active|expired|info" icon={Mail} dot="#0ea5e9">texto</Badge>
 *  - icon: componente de lucide-react (12px, a la izquierda).
 *  - dot: color del punto (6px) que sustituye al icono; suele venir de la entidad.
 */

const toneClasses = {
  waiting:  "bg-v25-waiting-bg text-v25-waiting-fg border-v25-waiting-bd",
  received: "bg-v25-received-bg text-v25-received-fg border-v25-received-bd",
  progress: "bg-v25-progress-bg text-v25-progress-fg border-v25-progress-bd",
  active:   "bg-v25-active-bg text-v25-active-fg border-v25-active-bd",
  expired:  "bg-v25-expired-bg text-v25-expired-fg border-v25-expired-bd",
  info:     "bg-v25-info-bg text-v25-info-fg border-v25-info-bd",
};

export function Badge({ tone = "info", icon: Icon, dot, className, children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 whitespace-nowrap rounded-v25-full border px-2 py-0.5 text-[11px] font-medium",
        toneClasses[tone] || toneClasses.info,
        className
      )}
      {...props}
    >
      {dot ? (
        <span
          className="h-1.5 w-1.5 rounded-v25-full"
          style={typeof dot === "string" ? { background: dot } : undefined}
        />
      ) : Icon ? (
        <Icon className="h-3 w-3" />
      ) : null}
      {children}
    </span>
  );
}
